import * as constants from './constants';
import { ICommands } from './interfaces';
import { CommandsActionTypes } from './actions';

const initialState: ICommands = {
  commandsRequesting: false,
  errored: false,
  errorMsg: '',
  list: [],
};

const commandsReducer = (
  state = Object.assign({}, initialState),
  action: CommandsActionTypes,
): ICommands => {
  switch (action.type) {
    case constants.COMMANDS_REQUEST:
      return { ...Object.assign({}, initialState), commandsRequesting: true };

    case constants.COMMANDS_FULFILLED:
      return { ...Object.assign({}, initialState) };

    case constants.COMMANDS_REJECTED:
      return {
        ...Object.assign({}, initialState),
        errored: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default commandsReducer;
